export default __webpack_public_path__ + "static/dev-siteplan-3188872d0943532577770c181eccaf12.jpg";